import { useState } from 'react';

function RenderButton() {
  window.google?.accounts.id.renderButton(
    document.getElementById('google-login-button'),
    {
      // customization attributes
      theme: 'outline',
      type: 'icon',
      size: 'large',
      shape: 'circle',
      width: '64',
    }
  );
}

const initGoogleeSdk = (callback) => {
  // if google sdk already loaded, do nothing
  if (window.google || document.getElementById('google-sdk')) {
    // check if the Google buttons was rendered
    const googleLoginButtonDiv = document.getElementById('google-login-button');
    const iframeInsideDiv = googleLoginButtonDiv?.querySelector('iframe');
    if (!iframeInsideDiv) {
      RenderButton();
    }
    return;
  }

  // add google sdk script
  const script = document.createElement('script');
  script.id = 'google-sdk';
  script.src = 'https://accounts.google.com/gsi/client';
  script.async = true;
  script.defer = true;

  script.onload = function () {
    window.google.accounts.id.initialize({
      client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
      callback,
    });
    RenderButton();
    // window.google.accounts.id.prompt(); // also display the One Tap dialog
  };
  document.body.appendChild(script);
};

export default function useGoogleLogin() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  const handleResponse = (response) => {
    if (response.error) {
      setError(true);
    } else {
      setData(response);
    }
  };

  initGoogleeSdk(handleResponse);

  return [data, error];
}
